<script lang="ts" setup>
import { AlgoliaDropdownsPriceProps } from "./AlgoliaDropdownsPrice.props"

const props = defineProps<AlgoliaDropdownsPriceProps>()

const emit =
  defineEmits<{
    (e: "onToggle", value: boolean): void
    (e: "onDelete"): void
    (e: "onApply"): void
  }>()

const { event, sendEvent } = useGAEvent(
  `track_select_content_${props.facetName}_`,
  "custom_event"
)
const startRange = ref<null | { min: number; max: number }>(null)

const handleGtm = (
  filter: { min: number; max: number },
  category: string,
  range: { min: number; max: number },
  oldValue: { min: number; max: number }
) => {
  if (startRange.value === null) {
    startRange.value = { ...range }
    return
  }

  if (
    (startRange.value?.min !== range.min ||
      startRange.value?.max !== range.max) &&
    oldValue.min === filter.min &&
    oldValue.max === filter.max
  ) {
    startRange.value = { ...range }
    return
  }

  event.value = {
    event: "select_content",
    action: "filter",
    category: category.toLowerCase(),
    label: `${filter.min ?? 0} - ${filter.max ?? 0}`
  }

  sendEvent({ clearEcommerce: false })
}

const closeDropdown = (resetOptions: any) => {
  emit("onToggle", resetOptions)
}
// console.log(route.query, route.params)
</script>

<template>
  <FiltersUtilsDropdown
    content-class="w-[24.5rem] p-4"
    :text="$t('filters.utils.common.price')"
    :opened="opened"
    is-price
    id-facet="price.amount_float"
    :facetName="[facetName, 'isDiscounted']"
    @onToggle="closeDropdown"
    @onDelete="emit('onDelete')"
    @onApply="emit('onApply')"
  >
    <AisRangeInput :attribute="facetName">
      <template v-slot="{ currentRefinement, range, refine }">
        <FkSlider
          :model-value="{
            min:
              typeof currentRefinement.min === 'number'
                ? currentRefinement.min
                : range.min,
            max:
              typeof currentRefinement.max === 'number'
                ? currentRefinement.max
                : range.max
          }"
          name="range"
          :label="$t('filters.utils.common.price')"
          :min="range.min"
          :max="range.max"
          :step="1"
          :gap="1"
          currency="€"
          @update:model-value="
            ($event) => {
              handleGtm(
                {
                  min: $event.min,
                  max: $event.max
                },
                $t('filters.utils.common.price'),
                range as any,
                currentRefinement as any
              )
              refine({ min: $event.min, max: $event.max })
            }
          "
        />
      </template>
    </AisRangeInput>
    <div class="pt-2">
      <AisToggleRefinement
        attribute="isDiscounted"
        :label="$t('filters.utils.price.isDiscounted')"
      >
        <template v-slot="{ canRefine, refine, value }">
          <FiltersUtilsOption
            name="is-discounted"
            :checked="value.isRefined"
            :disabled="!canRefine"
            @clicked="refine(value)"
            :text="$t('filters.utils.price.isDiscounted')"
            :n-results="canRefine ? value.count : 0"
            type="toggle"
          />
        </template>
      </AisToggleRefinement>
    </div>
  </FiltersUtilsDropdown>
</template>
